import MtnZAService from "@/services/mtnZAService";

export const brandConfigObjectMap = new Map();

export const Brands = {
    VodacomSouthAfricaEnglish: 'vc-za-en',
    VodacomEvinaSouthAfricaEnglish: 'vc-encrypt-za-en',
    MtnSouthAfricaEnglish: 'mtn-za-en',
    TelkomWorldPlaySouthAfticaEnglish: 'telkom-wp-za-en',
    MTNWorldPlaySouthAfticaEnglish: 'mtn-wp-za-en',
    WorldPlaySouthAfticaEnglish: 'wp-za-en',
    WorldPlayRuggaNationSouthAfricaEnglish: 'wp-rn-za-en',
};

brandConfigObjectMap.set(Brands.VodacomSouthAfricaEnglish, {
    gameTitle: 'Rugby Zone',
    freePlayServiceId: 'rugby-free',
    baseRoute: '/home',
    productId: 28,
    logoLrg: require('@/brand/vc-za-en/assets/illustrations/logo-lrg.webp'),
    logoSml: require('@/brand/vc-za-en/assets/illustrations/logo-sml.webp'),
    hasBracketGames: true,
});
brandConfigObjectMap.set(Brands.MtnSouthAfricaEnglish, {
    gameTitle: 'Rugby Zone',
    freePlayServiceId: 'rugby-free',
    baseRoute: '/home',
    productId: 56,
    logoLrg: require('@/brand/mtn-za-en/assets/illustrations/logo-lrg.webp'),
    logoSml: require('@/brand/mtn-za-en/assets/illustrations/logo-sml.webp'),
    hasBracketGames: false,
});

// WorldPlay brands only: Text Logo (logo2) = top header. Main Logo (logo1) = all other contexts.
brandConfigObjectMap.set(Brands.WorldPlaySouthAfticaEnglish, {
    gameTitle: 'Rugby Zone World Play',
    freePlayServiceId: 'rugby-free',
    baseRoute: '/home',
    productId: 56, // TODO: Needs to change based off network... How we going to do this? || Check users number for mtn or telkom. default to mtn for now
    logoLrg: require('@/brand/wp-za-en/assets/illustrations/Logo-big-1.png'),
    logoSml: require('@/brand/wp-za-en/assets/illustrations/Logo-small-1.png'),
    logoHeaderLrg: require('@/brand/wp-za-en/assets/illustrations/Logo-big-2.png'),
    logoHeaderSml: require('@/brand/wp-za-en/assets/illustrations/Logo-small-2.png'),
    logoMainLrg: require('@/brand/wp-za-en/assets/illustrations/Logo-big-1.png'),
    logoMainSml: require('@/brand/wp-za-en/assets/illustrations/Logo-small-1.png'),
    logoUpcomingFixtures: require('@/brand/wp-za-en/assets/illustrations/Logo-medium-1.png'),
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.MTNWorldPlaySouthAfticaEnglish, {
    gameTitle: 'Rugby Zone World Play',
    freePlayServiceId: 'rugby-free',
    baseRoute: '/home',
    productId: 56,
    serviceClass: MtnZAService,
    logoLrg: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-big-1.png'),
    logoSml: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-small-1.png'),
    logoHeaderLrg: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-big-2.png'),
    logoHeaderSml: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-small-2.png'),
    logoMainLrg: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-big-1.png'),
    logoMainSml: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-small-1.png'),
    logoUpcomingFixtures: require('@/brand/mtn-wp-za-en/assets/illustrations/Logo-medium-1.png'),
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.WorldPlayRuggaNationSouthAfricaEnglish, {
    gameTitle: 'Rugga Nation',
    freePlayServiceId: 'rugby-free',
    baseRoute: '/home',
    productId: 314,
    userAccessId: 18,
    logoLrg: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-big-1.png'),
    logoSml: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-small-1.png'),
    logoHeaderLrg: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-big-2.png'),
    logoHeaderSml: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-small-2.png'),
    logoMainLrg: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-big-1.png'),
    logoMainSml: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-small-1.png'),
    logoUpcomingFixtures: require('@/brand/wp-rn-za-en/assets/illustrations/Logo-medium-1.png'),
    hasBracketGames: false,
});

brandConfigObjectMap.set(Brands.TelkomWorldPlaySouthAfticaEnglish, {
    gameTitle: 'Rugby Zone World Play',
    freePlayServiceId: 'rugby-free',
    baseRoute: '/home',
    productId: 59,
    // TODO: Need Telkom binds for a service here...
    logoLrg: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-big-1.png'),
    logoSml: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-small-1.png'),
    logoHeaderLrg: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-big-2.png'),
    logoHeaderSml: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-small-2.png'),
    logoMainLrg: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-big-1.png'),
    logoMainSml: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-small-1.png'),
    logoUpcomingFixtures: require('@/brand/telkom-wp-za-en/assets/illustrations/Logo-medium-1.png'),
    hasBracketGames: false,
});


